export { default as Home } from './Home';
export { default as Soap } from './Soap';
export { default as Ptinfo } from './Ptinfo';
export { default as Ptdoc } from './Ptdoc';
export { default as Search } from './Search';
